module.exports = __webpack_public_path__ + "media/images/icons/outlined/search-e33aa64fb8677fc42daece4ea5712a6c.svg";